import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelectedCategory(value);
    if (value) {
      window.open(value, '_blank', 'noopener,noreferrer');
      setSelectedCategory('');
    }
  };

  return (
    <section id="categories" className="relative w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-900 mb-3">
            Browse Product Categories
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Explore our curated fashion collections. Each category opens directly to the matching store page.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-10 md:mb-14">
          <div className="relative">
            <select
              value={selectedCategory}
              onChange={handleDropdownChange}
              className="w-full appearance-none bg-background-100 border border-background-300 rounded-lg px-5 py-3.5 text-foreground-800 text-base font-medium cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400 transition-all duration-200"
            >
              <option value="">— Choose a Category —</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.url}>
                  {cat.name}
                </option>
              ))}
            </select>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
              <i className="ri-arrow-down-s-line text-foreground-500 w-5 h-5 flex items-center justify-center"></i>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  title={`${cat.name} - BaseTao Spreadsheet Category`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 flex items-center justify-between">
                <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors duration-200 whitespace-nowrap truncate">
                  {cat.name}
                </span>
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center text-foreground-400 group-hover:text-primary-500 opacity-0 group-hover:opacity-100 transition-all duration-200 flex-shrink-0"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}